import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-6" }
const _hoisted_2 = { class: "d-flex fw-bold text-fprimary" }
const _hoisted_3 = { class: "ms-4 badge rounded-pill bg-danger" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_5 = { class: "d-flex align-items-center gap-4" }
const _hoisted_6 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.t("institution")), 1),
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.listClubs.length) + " ", 1),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          placeholder: _ctx.t('search')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.idcheckdoc,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.idcheckdoc) = $event)),
          multiple: "",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          placeholder: "Estado",
          class: "w-300px",
          onChange: _ctx.onChangeStatus
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id,
                disabled: _ctx.idcheckdoc.length === 1 && _ctx.idcheckdoc.includes(item.id)
              }, null, 8, ["label", "value", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    (_ctx.listClubs.length>0)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.filteredClubs,
          ref: "singleTableRef",
          border: "",
          "show-summary": "",
          class: "w-100",
          "table-layout": 'auto',
          "header-cell-class-name": "text-black bg-secondary text-uppercase",
          "highlight-current-row": "",
          "scrollbar-always-on": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              width: "70",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('country'),
              width: "140"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_6, [
                  (row.country?.flag)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: `${_ctx.REPO}/${row.country?.flag}`,
                        class: "w-24px h-15px border rounded"
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.country?.name.toUpperCase()), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "abrev",
              label: _ctx.t('acronym'),
              width: "120"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _ctx.t('institution')
            }, null, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicColumns, (col) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: col.prop,
                prop: col.prop,
                label: col.label,
                width: col.width,
                align: col.align
              }, null, 8, ["prop", "label", "width", "align"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              prop: "quantity",
              label: "Total",
              width: "70"
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "Opciones",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  round: "",
                  plain: "",
                  onClick: ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'sumary-participation-club', { a:_ctx.evento.idevent, b: scope.row.idinstitution, c:'' }))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Donwload")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No se encontrarón registros"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getListClubs
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volver a intentar")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loader]
        ])
  ], 64))
}